const projects = [
  {
    id: 1,
    name: "Petto",
    images: [
      "https://res.cloudinary.com/dx1ye2bro/image/upload/v1649229770/Screenshot_from_2022-03-27_11-50-45_k8zqdx.png",
      "https://res.cloudinary.com/dx1ye2bro/image/upload/v1649229770/Screenshot_from_2022-03-27_11-51-25_f0t5aq.png",
      "https://res.cloudinary.com/dx1ye2bro/image/upload/v1649229764/Screenshot_from_2022-03-27_11-50-54_psgewu.png",
      "https://res.cloudinary.com/dx1ye2bro/image/upload/v1649229761/Screenshot_from_2022-03-27_11-53-05_an6jqp.png",
      "https://res.cloudinary.com/dx1ye2bro/image/upload/v1649229769/Screenshot_from_2022-03-27_11-51-10_q5t95r.png",
      "https://res.cloudinary.com/dx1ye2bro/image/upload/v1649229760/Screenshot_from_2022-03-27_11-52-00_wlqjnr.png",
    ],
    overview: "A platform for all pet lovers and pet care takers.",
    description:
      "Petto is an platform where pet owners can search for the best pet care takers around them and filter them out. They can also apply to a pet care taler themselves by submitting the identification and work proofs. Also this has a fully working chat and payment system to make things easy for the owners and care takers.",
    len: 5,
    tech: [3, 4, 5, 9, 10],
    website: "https://petto.netlify.app/",
    github: "https://github.com/TMTuringMachine/PetsCape_CodeBreak3.0",
  },

  {
    id: 2,
    name: "Studify",
    images: [
      "https://res.cloudinary.com/dx1ye2bro/image/upload/v1649229946/Screenshot_from_2022-01-30_16-20-47_dakkc9.png",
      "https://res.cloudinary.com/dx1ye2bro/image/upload/v1649229951/Screenshot_from_2022-01-30_16-21-17_kqf9ei.png",
      "https://res.cloudinary.com/dx1ye2bro/image/upload/v1649229950/Screenshot_from_2022-01-30_16-21-29_ixwa0u.png",
      "https://res.cloudinary.com/dx1ye2bro/image/upload/v1649229942/Screenshot_from_2022-01-30_16-21-03_vfz5my.png",
      "https://res.cloudinary.com/dx1ye2bro/image/upload/v1649229952/Screenshot_from_2022-01-22_19-09-10_tkwxby.png",
      "https://res.cloudinary.com/dx1ye2bro/image/upload/v1649229952/Screenshot_from_2022-01-22_19-09-33_x84o89.png",
    ],
    overview: "An online education platform like udemy.",
    description:
      "Studify is a online education platform where students can search and purchase courses from top educators. If a student wish to become an educator himself he can become on too by verifying himself with some id proof and creating a course. This project has a full fledged video playing and payment system. This project secured 1st place in Unscript Rookies hackathon under the web domain!",
    len: 4,
    tech: [3, 4, 5, 9, 10],
    website: "https://studify4.herokuapp.com/",
    github: "https://github.com/AryanShinde/Unscript2k22_TuringMachine",
  },
  {
    id: 3,
    name: "Follow Up",
    images: [
      "https://res.cloudinary.com/dx1ye2bro/image/upload/v1649230073/Screenshot_from_2022-02-27_19-13-22_yg6dhu.png",
      "https://res.cloudinary.com/dx1ye2bro/image/upload/v1649230072/Screenshot_from_2022-02-27_19-14-09_zzitq5.png",
      "https://res.cloudinary.com/dx1ye2bro/image/upload/v1649230072/Screenshot_from_2022-02-27_19-14-31_nvdu13.png",
      "https://res.cloudinary.com/dx1ye2bro/image/upload/v1649230069/Screenshot_from_2022-02-27_19-14-44_z7yqiv.png",
      "https://res.cloudinary.com/dx1ye2bro/image/upload/v1649230080/Screenshot_from_2022-02-27_19-15-11_wxwjdq.png",
      "https://res.cloudinary.com/dx1ye2bro/image/upload/v1649230091/Screenshot_from_2022-02-27_19-32-50_hyl1r5.png",
      "https://res.cloudinary.com/dx1ye2bro/image/upload/v1649230091/Screenshot_from_2022-02-27_19-32-58_nwfo4k.png",
      "https://res.cloudinary.com/dx1ye2bro/image/upload/v1649230092/Screenshot_from_2022-02-27_19-33-34_vzkt91.png",
      "https://res.cloudinary.com/dx1ye2bro/image/upload/v1649230092/Screenshot_from_2022-02-27_19-33-18_fhrbfm.png",
      "https://res.cloudinary.com/dx1ye2bro/image/upload/v1649230091/Screenshot_from_2022-02-27_19-33-09_ru7c0j.png",
    ],
    overview: "A teacher parent interface that makes life easy for both !",
    description:
      "FollowUp is a all in one solution for teachers to directly interact with the student's parents. Teacher can create class,take attendance, update students marks, upload announcements and at the same time each of these can be viewed by the parent. Parent can also view the graphical representations of theirs childs progress and their performace in each subject. They can also provide feedback to the class teacher. This project won 2nd price in HackNYU international hackathon under Education track! ",
    len: 3,
    tech: [3, 4, 5, 8, 9],
    website: "https://followup2.herokuapp.com/",
    github: "https://github.com/AryanShinde/HackNYU_Hackathon",
  },

  {
    id: 4,
    name: "Chat Box",
    images: [
      "https://res.cloudinary.com/dx1ye2bro/image/upload/v1649230688/Screenshot_from_2022-04-06_13-02-38_zms2yt.png",
      "https://res.cloudinary.com/dx1ye2bro/image/upload/v1649230681/Screenshot_from_2022-04-06_13-02-10_ovvrvz.png",
      "https://res.cloudinary.com/dx1ye2bro/image/upload/v1649230688/Screenshot_from_2022-04-06_13-02-56_vbwrpe.png",
      "https://res.cloudinary.com/dx1ye2bro/image/upload/v1649230688/Screenshot_from_2022-04-06_13-02-46_cms6mg.png",
      "https://res.cloudinary.com/dx1ye2bro/image/upload/v1649230683/Screenshot_from_2022-04-06_13-03-20_ih9nbo.png",
      "https://res.cloudinary.com/dx1ye2bro/image/upload/v1649230683/Screenshot_from_2022-04-06_13-03-27_o5eoak.png",
    ],
    overview: "A realtime chat app for group chats and personal chats",
    description:
      "Chatbox is a platfoem where users can join eisting rooms or create rooms and chat there. They can also hava one on one conversations with other users! ",
    len: 3,
    tech: [3, 5, 7],
    website: "http://itschatbox.herokuapp.com/",
    github: "https://github.com/Shivam256/chat-box",
  },
  {
    id: 5,
    name: "Code Box",
    images: [
      "https://res.cloudinary.com/dx1ye2bro/image/upload/v1649230756/Screenshot_from_2022-04-06_13-04-27_kgvdih.png",
      "https://res.cloudinary.com/dx1ye2bro/image/upload/v1649230753/Screenshot_from_2022-04-06_13-04-34_dweylc.png",
      "https://res.cloudinary.com/dx1ye2bro/image/upload/v1649230752/Screenshot_from_2022-04-06_13-05-11_tq7bw3.png",
      "https://res.cloudinary.com/dx1ye2bro/image/upload/v1649230752/Screenshot_from_2022-04-06_13-05-35_jc9tjt.png",
      "https://res.cloudinary.com/dx1ye2bro/image/upload/v1649230752/Screenshot_from_2022-04-06_13-05-19_l7qa4k.png",
      "https://res.cloudinary.com/dx1ye2bro/image/upload/v1649230752/Screenshot_from_2022-04-06_13-05-27_gprsoi.png",
    ],
    overview:
      "An online code editor for many programming languages with a web editor too!",
    description:
      "Codebox is a place where users can run codes of various programming languages and can also save their code and edit it later which makes it more flexible to use. For the web developers it also as a web playground where users can write html css and javascript code and view the results immediately!",
    len: 5,
    tech: [1, 4, 8, 9, 15],
    website: "http://itscodebox.herokuapp.com/",
    github: "https://github.com/Shivam256/codebox",
  },
  {
    id: 6,
    name: "Yoga dictionary",
    images: [
      "https://res.cloudinary.com/dx1ye2bro/image/upload/v1649230822/Screenshot_from_2022-04-06_13-06-43_xjk8db.png",
      "https://res.cloudinary.com/dx1ye2bro/image/upload/v1649230811/Screenshot_from_2022-04-06_13-06-52_ytiluo.png",
      "https://res.cloudinary.com/dx1ye2bro/image/upload/v1649230811/Screenshot_from_2022-04-06_13-07-02_il9tld.png",
      "https://res.cloudinary.com/dx1ye2bro/image/upload/v1649230823/Screenshot_from_2022-04-06_13-07-09_rey4fu.png",
    ],
    overview: "A simple website to get all info about yoga that you require.",
    description:
      "This is a simple static website that provides lot of information about yoga positions and yoga.Users can search yoga positions by name or filter them by type and can read yoga articles!",
    len: 4,
    tech: [0, 1, 2, 15],
    website: "https://yoga-dictionary.netlify.app/",
    github: "https://github.com/Shivam256/yoga-dictionary-responsive",
  },
];

//studify
//follow up
//code showcase
//chat box
//code box
//yoga dictionary

export default projects;
